import Slider from '../components/slider';

export default function MacalyAiPackages() {
  return {
    selectedIndex: 0,
    selectedPeriod: 1,
    panels: [],
    isSyncingSliders: false,
    product: 'ai-builder',
    proUuid: '',
    priceSoon: '',

    init() {
      const data = this.$el.dataset;

      this.product = data.product || 'ai-builder';
      this.proUuid = data.proUuid || '';
      this.priceSoon = data.priceSoon || '';
      this.selectedPeriod = Number(data.defaultPeriod) || 1;

      this.initPanels();
    },

    initPanels() {
      this.panels = Array.from(this.$el.querySelectorAll('.js-macaly-panel')).map((el) => {
        let creditSteps = [];

        try {
          creditSteps = JSON.parse(el.dataset.creditSteps || '[]');
        } catch {
          creditSteps = [];
        }

        return { el, period: Number(el.dataset.period) || 1, creditSteps, slider: null };
      });

      this.panels.forEach((panel) => this.initCreditsSlider(panel));
    },

    initCreditsSlider(panel) {
      const container = panel.el.querySelector('.js-range-slider');

      if (!container || panel.creditSteps.length === 0) {
        return;
      }

      const slider = new Slider(container);

      panel.slider = container.querySelector('.js-range-slider__slider').noUiSlider;

      // `update` also covers track taps and keyboard, unlike `slide`/`change`.
      panel.slider.on('update', (values, handle, unencoded) => {
        slider.updateUnitLabelText(unencoded[0]);
        this.selectCredits(unencoded[0]);
      });
    },

    selectPeriod(period) {
      this.selectedPeriod = Number(period) || 1;
    },

    selectedStep(panel) {
      return panel.creditSteps[this.selectedIndex] || {};
    },

    selectCredits(index) {
      // Ignore the `update` events our own panel sync triggers.
      if (this.isSyncingSliders) {
        return;
      }

      this.selectedIndex = Math.round(Number(index)) || 0;

      this.syncSliders();
      this.panels.forEach((panel) => this.updatePanel(panel));
    },

    syncSliders() {
      this.isSyncingSliders = true;

      this.panels.forEach((panel) => panel.slider && panel.slider.set(this.selectedIndex));

      this.isSyncingSliders = false;
    },

    updatePanel(panel) {
      const step = this.selectedStep(panel);
      const card = panel.el.querySelector('.js-macaly-pro-card');

      if (card) {
        card.dispatchEvent(
          new CustomEvent('update-prices', {
            detail: {
              price: step.price || '',
              priceVat: step.priceVat || step.price || '',
              priceProlong: step.priceProlong || '',
              priceProlongVat: step.priceProlongVat || step.priceProlong || '',
              isInitialPrice: this.selectedIndex === 0,
            },
          }),
        );

        const note = card.querySelector('.product-card__price > span');

        if (note && !step.price) {
          note.textContent = this.priceSoon;
        }
      }

      panel.el.querySelectorAll('.js-macaly-credits-label').forEach((el) => {
        el.textContent = step.label || '';
      });

      this.updateCartParams(panel);
    },

    updateCartParams(panel) {
      const button = panel.el.querySelector('.js-macaly-pro-card .js-button-add-to-cart');

      if (!button?.attributes['@click']) {
        return;
      }

      const expression = button.attributes['@click'].nodeValue;

      if (!/{.*}/.test(expression)) {
        return;
      }

      button.attributes['@click'].nodeValue = expression.replace(/{.*}/, JSON.stringify(this.proCartParams(panel)));
    },

    proCartParams(panel) {
      return {
        uuid: this.proUuid,
        addons: { credits: Number(this.selectedStep(panel).value || 0) },
        product: this.product,
      };
    },
  };
}
